module.exports = __webpack_public_path__ + "static/img/heat-treatment-model.dde1deb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatment-model.jpg
// module id = EUoe
// module chunks = 1